import { maskJs } from "mask-js";
import React, { HTMLProps, KeyboardEvent, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { RiErrorWarningLine } from "react-icons/ri";
import CurrencyInput from "react-currency-input-field";
import "./styles.scss";

interface InputProps extends HTMLProps<HTMLInputElement> {
  mask?: string;
  maxLength?: number;
  error?: string;
  onlyNumbers?: boolean;
  changeCurrency?: (
    value: string | undefined,
    name: string | undefined,
    values: any
  ) => void;
}

const Input: React.FC<InputProps> = ({
  label,
  children,
  className,
  mask,
  type = "text",
  error,
  onlyNumbers,
  maxLength,
  changeCurrency,
  ...rest
}) => {
  const [typeInput, setTypeInput] = useState(type);
  const [showPassword, setShowPassword] = useState(false);

  function handleShowPassword() {
    setShowPassword(!showPassword);
    setTypeInput((prevValue) =>
      prevValue === "password" ? "text" : "password"
    );
  }

  function handleKeyUp(e: KeyboardEvent<HTMLInputElement>) {
    if (mask && mask !== "currency") {
      e.currentTarget.value = maskJs(mask, e.currentTarget.value);
    }

    if (maxLength) {
      e.currentTarget.maxLength = maxLength;
    }

    if (onlyNumbers) {
      e.currentTarget.value = e.currentTarget.value.replace(/\D/g, "");
    }
  }

  return (
    <label className="labelInput">
      {label && <span>{label}</span>}
      {mask !== "currency" ? (
        <div className={`containerButton ${error ? "error" : ""}`}>
          {children}
          <input onKeyUp={handleKeyUp} type={typeInput} {...rest} />
          {type === "password" && (
            <button type="button" onClick={handleShowPassword}>
              {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
            </button>
          )}
        </div>
      ) : (
        <div className={`containerButton ${error ? "error" : ""}`}>
          <CurrencyInput
            name={rest.name}
            // decimalsLimit={2}
            // decimalScale={2}
            // decimalSeparator=","
            prefix="R$"
            onValueChange={changeCurrency}
            value={rest.value}
            defaultValue={
              rest.defaultValue &&
              (typeof rest.defaultValue === "string" ||
                typeof rest.defaultValue === "number")
                ? rest.defaultValue
                : undefined
            }
          />
        </div>
      )}
      {error && (
        <div className="errorMessage">
          <RiErrorWarningLine size={24} />
          <span>{error}</span>
        </div>
      )}
    </label>
  );
};

export { Input };
